import PathCapabilitiesDto from "./PathCapabilitiesDto";

export default class PathListDto {

    Id: number;
    Name: string;
    TypeId: number;
    TypeLabel: string;
    CreatedBy: string;
    CreationDate: Date;
    UpdateDate: Date;
    CurrentPeriodRuns: number;
    AllPeriodsRuns: number;
    // Only filled when asked (withCapabilities) for the path types which have capabilities (MetaApi, AI) and a published version.
    Capabilities: PathCapabilitiesDto | null;

    constructor(
        id: number,
        name: string,
        typeId: number,
        typeLabel: string,
        createdBy: string,
        creationDate: string | Date,
        updateDate: string | Date,
        currentPeriodRuns: number,
        allPeriodsRuns: number,
        capabilities: PathCapabilitiesDto | null = null
    ) {
        this.Id = id;
        this.Name = name;
        this.TypeId = typeId;
        this.TypeLabel = typeLabel;
        this.CreatedBy = createdBy;
        this.CreationDate = new Date(creationDate);
        this.UpdateDate = new Date(updateDate);
        this.CurrentPeriodRuns = currentPeriodRuns;
        this.AllPeriodsRuns = allPeriodsRuns;
        this.Capabilities = capabilities;
    }
}
